import React from "react";

function Header(){
    return(
        <header className="header">Keeper App</header>
    )
}

export default Header